module.exports = __webpack_public_path__ + "media/images/icon__compete@2x-06bd4e0111622c9fee992fd230c74268.png";